import IC_NONE from "@/assets/record/ic_none.png";

interface IEmptyProps {
  text: string;
}

const Empty: React.FC<IEmptyProps> = ({ text }) => {
  return (
    <div className="flex flex-col flex-justify-center flex-items-center flex-1">
      <img src={IC_NONE} className="w-20 h-20" />
      <span className="mt-1 text-mx-quaternary text-3.5">{text}</span>
    </div>
  );
};

export default Empty;
